module.exports = __webpack_public_path__ + "img/ch09_13_樱花柄发带.46a4b47c.jpg";